import { createContext } from 'helpers/createContext';
import { Service } from 'types/interfaces/SiteConfig';

const [ServiceContextProvider, useServiceContext] = createContext<{ service: Service }>('EVENT');

export { ServiceContextProvider, useServiceContext };
